import React, { FC } from 'react';

import FlexColumn from '@ui/atoms/FlexColumn';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import fullWidth from '@ui/styled/FullWidth';

const FullWidthColumn = fullWidth(FlexColumn);

export interface IErrorContent {
	genericCopy: string;
	notFoundCopy: string;
}

interface IErrorProps {
	refinedContent: IErrorContent;
	path: string;
}

const Error: FC<IErrorProps> = ({ refinedContent, path }) => {
	const { genericCopy, notFoundCopy } = refinedContent;
	const copy = path === '/not-found' ? notFoundCopy : genericCopy;

	return (
		<FullWidthColumn>
			<WYSIWYGContent dangerouslySetInnerHTML={{ __html: copy }} />
		</FullWidthColumn>
	);
};

export { Error as default };
